var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getLoading)?_c('BlockUI',[_c('ThuxSpinner')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }